import React from 'react';
import { useDarkMode } from '../DarkMode';

const Footer = () => {
  const { isDarkMode } = useDarkMode();

  const getCurrentYear = () => {
    return new Date().getFullYear();
  };

  return (
    <footer id="footer" className={`flex ${isDarkMode ? 'bg-gray-600 text-white' : 'bg-gray-100 text-black'} mt-8 py-4 text-center w-full items-end bottom-0`}>
      <p className="mx-auto">&copy; Christian Ansel Fernandez, {getCurrentYear()} <br/> Netlify + React + TailwindCSS</p>
    </footer>
  );
};

export default Footer;
